import { FC } from "react";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";

import CardMediaVideoPlayerWithSpeedControls from "../../../pages/media-viewer/components/player/CardMediaVideoPlayerWithSpeedControls";
import CloseDialogIcon from "../icons/CloseDialogIcon";

interface VideoFullScreenProps {
  signedUrl: string;
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
}

const VideoFullScreen: FC<VideoFullScreenProps> = ({
  signedUrl,
  open,
  onClose,
  children,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          margin: 0,
          maxWidth: "100%",
          maxHeight: "100%",
          width: "100%",
          height: "100%",
          borderRadius: "8px",
          backgroundColor: theme.palette.otherFullScreenBackground.main,
        },
      }}
    >
      {children ? (
        children
      ) : (
        <DialogContent
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0px",
            width: "100%",
            height: "100%",
            overflowY: "hidden",
          }}
        >
          {open && (
            <Box sx={{ position: "relative" }}>
              <CardMediaVideoPlayerWithSpeedControls
                sx={{
                  maxWidth: "80vw",
                  maxHeight: "80vh",
                }}
                controls
                src={signedUrl}
                autoPlay
              />
              <Box
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  zIndex: 2,
                }}
                onClick={onClose}
              >
                <CloseDialogIcon onClose={onClose} />
              </Box>
            </Box>
          )}
        </DialogContent>
      )}
    </Dialog>
  );
};

export default VideoFullScreen;
